// 9fbef606107a605d69c0edbcd8029e5d
import { getPlaceSiteId } from '@tcp/core/src/utils';
import { executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';

const errorMsg = 'res body is null';

export const getSocialAccountsInformation = () => {
  const payload = {
    header: {
      siteId: getPlaceSiteId(),
    },
    webService: endpoints.getSocialAccountsInfo,
  };
  return executeStatefulAPICall(payload)
    .then((res) => {
      if (!res?.body?.data) {
        throw new Error(errorMsg);
        // TODO - Set API Helper to filter if error exists in response
      }
      return res?.body?.data || [];
    })
    .catch((err) => {
      throw err;
    });
};

export const saveSocialAccountsInfo = (arg) => {
  const payload = {
    header: {
      siteId: getPlaceSiteId(),
    },
    body: {
      [arg.accountName]: {
        accessToken: arg.token,
        userId: arg.userId,
      },
    },
    webService: endpoints.saveSocialAccountsInfo,
  };

  return executeStatefulAPICall(payload)
    .then((response) => {
      if (!response?.body?.data) {
        throw new Error(errorMsg);
        // TODO - Set API Helper to filter if error exists in response
      }
      return response?.body?.data || [];
    })
    .catch((err) => {
      throw err;
    });
};

/**
 * @param {string} code - The code from mule response on instagram API
 * @param {string} redirectUrl - The redirection URL after success from instagram
 */
export const getInstagramAccessToken = ({ code, redirectUrl }) => {
  const { method, URI } = endpoints.getInstagramAccessToken;
  const payload = {
    header: {
      siteId: getPlaceSiteId(),
    },
    webService: {
      method,
      URI: `${URI}?code=${code}&redirectUri=${redirectUrl}`,
    },
  };

  return executeStatefulAPICall(payload)
    .then((res) => {
      if (!res?.body?.data) {
        throw new Error(errorMsg);
        // TODO - Set API Helper to filter if error exists in response
      }
      return res?.body?.data;
    })
    .catch((err) => {
      throw err;
    });
};
